import styled from 'styled-components';
import { Link } from "react-router-dom";
import { Navbar } from 'reactstrap';

export const Center = styled(Link)`
    display: flex;
`;

export const Sombra = styled.div`
    display: grid;
    justify-content: center;
    width: 100%;
    border-radius: 30px;
    background-color: #277EB3;
    padding: 30px 0;
    gap: 10px;
    position: absolute;
    z-index: 2;
`;

export const Text = styled.div`
    display: grid;
    justify-content: center;
    font-size: 8px;
    font-weight: bold;
`;

export const Title = styled.text`
    font-size: 12px;
    font-weight: bold;
    text-transform: uppercase; 
`;

export const SubTitle = styled.text`
    font-size: 8px;
`;

export const Sombra2 = styled.div`
    width: 100%;
    border-radius: 30px;
    background-color: var(--secondary);
    bottom: 0;
    position: absolute;
    margin-bottom: 155px;
`;

export const Container = styled.div`
    display: flex;
    align-items: center;
    cursor: pointer;
`;

export const Nome = styled.text`
    font-size: 12px;
    font-weight: bold;
    color: #FFFFFF;
    margin-right: 5px;
`;

export const Cargo = styled.text`
    font-size: 8px;
    color: #FFFFFF;
    margin-right: 5px;
`;

export const InfoUser = styled.div`
    display: grid;
    text-align: right;

    @media (max-width: 1024px) {
        display: none;
    }
`;

export const DivDown = styled.div`
    @media (max-width: 1024px) {
        display: none;
    }
`;

export const DivDownMobile = styled.div`
    margin-top: -10px;
    margin-left: 10px;
    @media (min-width: 1025px) {
        display: none;
    }
`;

export const CustomNavbar = styled(Navbar)`
    background-color: #ff0000;
`;

export const SubTitle2 = styled.text`
    font-size: 8px;
    font-weight: 200;
    color: #FFFFFF;
`;

export const Geral = styled.div`
    height: 100vh;
    padding-top: 10px;
    background-color: #F3F6FA;
    border-radius: 20px 0 0 20px;
    display: flex;
    justify-content: center;
`;

export const Linha = styled.div`
    height: 100vh;
    margin-left: 0px;
    margin-top: -10px;
    border-right: 2px solid #277EB3;
`;

export const DivTeste = styled.div`
    @media (max-width: 992px){
        display: none;
    }
`;
